const NewsBox = (typ : string, title : string, description  : string, data : string) => (
    <article
        className="bg-white/5 backdrop-blur-sm rounded-2xl border border-white/10 overflow-hidden hover:border-orange-500/50 transition-all duration-300 group">
        <div className="p-8">
            <span className="text-orange-500 text-sm font-semibold">{typ}</span>
            <h3 className="text-xl font-bold text-white mt-3 mb-4">{title}</h3>
            <p className="text-gray-400 mb-6">{description}</p>
            <div className="flex items-center text-sm text-gray-500">
                <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
                </svg>
                {data}
            </div>
        </div>
    </article>
)

export default NewsBox